export default __webpack_public_path__ + "static/media/Cross.5f298fd7.svg";